import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/umea")(
  heritageCityRoute({
    citySlug: "umea",
    angle:
      "I Umeå och Västerbotten arbetar vi med både universitets- och vårdmiljöer och med familjer som vill bevara berättelser från byar och orter i inlandet innan de går förlorade.",
    localUseCases: [
      "Livsberättelse med förälder eller morförälder i Umeå",
      "Släkthistoria från byar och inland i Västerbotten",
      "Kunskapsöverföring i vård-, forsknings- och teknikmiljöer",
      "Grundarporträtt i norrländska tillväxtbolag",
      "Företagshistoria och kulturdokumentation",
      "Minnesfilm till jubileum eller minnesstund"
    ],
  }),
);
